import { createSlice } from "@reduxjs/toolkit";
import { AuthInitialState } from "../../types";

const initialState: AuthInitialState = {
  access_token: undefined, // TODO:
  user: undefined,
  role: undefined, // TODO:
  authInfo: {
    id: undefined,
    role: undefined, // TODO:
  },
  notificationToken: "",
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    userLoggedIn: (state, action) => {
      state.access_token = action.payload?.access_token;
      state.user = action.payload?.user;
      state.role = action.payload?.role;
    },
    userLoggedOut: (state) => {
      state.access_token = undefined;
      state.user = undefined;
      state.role = undefined;
      // localStorage.removeItem(AUTH_LOCALSTORAGE_NAME);
    },
    setAuthInfo: (state, action) => {
      state.authInfo = {
        ...action?.payload,
      };
    },
    setToken(state, action) {
      state.access_token = action.payload?.access_token;
      localStorage.setItem("kc-token", JSON.stringify(action.payload));
    },
    clearAuth(state) {
      state.access_token = undefined;
      localStorage.removeItem("kc-token");
    },
  },
});

export const { userLoggedIn, userLoggedOut, setAuthInfo, setToken, clearAuth } =
  authSlice.actions;
export default authSlice.reducer;
